import { Link } from "react-router-dom";
import { Phone, MessageCircle, Check, UserRound, CalendarPlus } from "lucide-react";
import { fmtDateTime, fmtTime, urgency, telLink, waLink, gcalLink } from "@/lib/crm";

const BADGE = {
  scaduto: "bg-rose-500 text-white",
  oggi: "bg-amber-400 text-slate-950",
  futuro: "bg-sky-100 text-sky-800",
};

export const ReminderRow = ({ r, onComplete, onMessage, showDate }) => {
  const u = urgency(r.due_at);
  return (
    <div data-testid={`reminder-row-${r.reminder_id}`} className="group flex items-center gap-4 py-3.5 px-4 border-b border-slate-100 last:border-0 hover:bg-slate-50/80 transition-colors">
      <span className={`shrink-0 font-mono text-xs px-2 py-1 rounded-md ${BADGE[u]}`}>
        {showDate || u !== "oggi" ? fmtDateTime(r.due_at) : fmtTime(r.due_at)}
      </span>
      <div className="min-w-0 flex-1">
        <Link to={`/clienti/${r.client_id}`} className="font-medium text-slate-900 hover:text-sky-700">{r.client_name}</Link>
        <p className="text-sm text-slate-500 truncate">
          {r.requested_by === "cliente" && <span className="inline-flex items-center gap-1 text-sky-700 mr-2"><UserRound className="h-3 w-3" />su richiesta</span>}
          {r.reason || "Richiamo"}
        </p>
      </div>
      <div className="flex items-center gap-1">
        {r.client_phone && (
          <>
            <a data-testid={`call-${r.reminder_id}`} href={telLink(r.client_phone)} className="h-9 w-9 grid place-items-center rounded-full hover:bg-slate-200 text-slate-600" title="Chiama"><Phone className="h-4 w-4" /></a>
            <a data-testid={`wa-${r.reminder_id}`} href={waLink(r.client_phone, "")} target="_blank" rel="noreferrer" className="h-9 w-9 grid place-items-center rounded-full hover:bg-green-100 text-green-600" title="WhatsApp"><MessageCircle className="h-4 w-4" /></a>
          </>
        )}
        <a data-testid={`gcal-${r.reminder_id}`} href={gcalLink(r)} target="_blank" rel="noreferrer" className="h-9 w-9 grid place-items-center rounded-full hover:bg-sky-100 text-sky-700" title="Aggiungi a Google Calendar"><CalendarPlus className="h-4 w-4" /></a>
        {onMessage && (
          <button data-testid={`message-${r.reminder_id}`} onClick={() => onMessage(r)} className="hidden sm:block text-xs px-3 py-1.5 rounded-full border border-slate-200 hover:border-slate-500">Messaggio</button>
        )}
        <button data-testid={`complete-${r.reminder_id}`} onClick={() => onComplete(r)} className="h-9 w-9 grid place-items-center rounded-full bg-emerald-50 text-emerald-700 hover:bg-emerald-600 hover:text-white transition-colors" title="Fatto">
          <Check className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
